<template>
<div class="inbox">
  <STable v-show="visible" :columns="columns" :loadData="loadData" ref="table" @selectionChange="selectionChange" :select="true" @cellDblclick="handleClick">
    <template #sn='{ $index }'>
      {{ $index + 1 }}
    </template>
    <template #checkFlag="record">
      <div v-if="check === 1">
        <img v-if="record.row.checkFlag === -1" width="30" src="@/assets/img/read.png" alt="">
        <img v-else width="30" src="@/assets/img/unread.png" alt="">
      </div>
      <img v-if="check === 2" width="30"  src="@/assets/img/email3-2.png" alt="">
      <img v-if="check === 3" width="30"  src="@/assets/img/email4-2.png" alt="">
      <img v-if="check === 4" width="30"  src="@/assets/img/email5-2.png" alt="">
    </template>
    <template #icon="record">
      <img v-if="record.row.oaEmailFileVoList.length" width="30" src="@/assets/img/file.png" alt="">
    </template>
  </STable>
  <div class="editor" v-if="!visible">
    <WriteEmail :type="check" :visible.sync="visible" :record="record" @reset="handleReset"/>
  </div>
</div>
</template>

<script>
import STable from '@/components/STable';
import WriteEmail from './WriteEmail'
import { Email } from '@/api/email'
export default {
  props: {
    check:{
      type: Number
    },
    total:{
      type: Number
    },
    input:{
      type:String
    },
    flag:{
      type:Boolean
    }
  },
  components: {
    STable,
    WriteEmail
  },
  watch:{
    check:{
      deep:true,
      immediate: true,
      handler(val){
        this.handleReset()
        this.visible = true
        this.loading = false
      }
    },
    visible:{
      deep : true,
      immediate:true,
      handler(val){
        this.$emit('update:flag',val)
      }
    },
  },
  data () {
    return {
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 70
        },
        {
          label: '',
          scopedSlots: 'checkFlag',
          width: 120
        },
        {
          label: '发件人',
          prop: 'senderName',
          ellipsis: true,
        },
        {
          label: '',
          scopedSlots: 'icon',
          width: 120
        },
        {
          label: '主题',
          prop: 'title',
          ellipsis: true
        },
        {
          label: '时间',
          prop: 'sendTime',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const oaEmailQueryDto = {
          emailType: this.check,
          query: this.input
        }
        return Email.getEmailList(this,{oaEmailQueryDto,pageParam}).then(rs => {
          this.$emit('update:total',rs.data.totalCount)
          return rs
        })
      },
      visible: true,
      loading: false,
      record:{}
    };
  },
  methods: {
    selectionChange(val){
      this.selectList = val
    },
    handleReset(flag = true){
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    delete(){
        this.$confirm('是否确定删除!', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const oaEmailOperateDto = {
            emailType : this.check,
            ids:this.selectList.map(item => {
              return item.emailType === 1 ? item.receiveId : item.id
            })
          }
          const deleteList = this.selectList.map(item => {
            return {
              id: item.emailType === 1 ? item.receiveId : item.id,
              emailType: item.emailType
            }
          })
          this.loading = true
          const api = this.check === 4 ? Email.deleteWaste(this,{deleteList}) : Email.putWaste(this,{oaEmailOperateDto})
          api.then(res => {
            this.selectList = []
            this.$refs.table.clearSelect()
            this.prompt('success', '删除成功!')
            this.handleReset()
          }).finally(() => {
            this.loading = false
          })
        }).catch(() => {
          this.prompt('info','已取消删除操作')          
        });
    },
    handleClick(record){
      this.record = {
        ...record
      }
      this.visible = false
    },
    //提示
    prompt(type,message){
      this.$message({
        type,
        message
      });
    },
  }
};
</script>